
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { translate } from 'react-polyglot'
// The same component is used for both versions
import ModalPasswordExpiration from '../../../components/layout/modals/ModalPasswordExpiration'
import authActions from '../../../actions/auth'

const mapStateToProps = state => ({
  showPasswordExpirationSoon: state.auth.alertPasswordExpiredSoon
})

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({ ...authActions, goToProfile: () => dispatch(push('/profile')) }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ModalPasswordExpiration))
